<div class="container py-5">
    <div *ngIf="form" [formGroup]="form" class="form">
        <div class="heading">
            <h1>Login</h1>
            <h5>Sign in to get the full access to Froodini</h5>
        </div>
        <label for="email">Email</label>
        <input type="email" class="form-control" id="email" formControlName="email">
        <label for="password">Password</label>
        <input type="password" class="form-control" id="password" formControlName="password">
        <button (click)="login()" class="btn btn-primary mt-3 btn-block" [disabled]="form.invalid">
            Login
        </button>
        <div *ngIf="error" class="error mt-3">
            {{error}}
        </div>
    </div>
</div>
